import { useState } from 'react';

export const useCreateNewCommandPrompt = (isNewCommandCreated) => {
  const [isPromptRaised, setIsPromptRaised] = useState(false);

  return {
    isPromptVisible: isPromptRaised && !isNewCommandCreated,
    raisePrompt: () => setIsPromptRaised(!isNewCommandCreated),
    dismissPrompt: () => setIsPromptRaised(false),
  };
};
